import React, { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import UploadeODA from "../Components/UploadeODA";
import { useNavigate } from "react-router-dom";

const UploadODAAdmin = () => {
  const navigate = useNavigate();
  const [userlog, setUserlog] = useState(localStorage.getItem("Logkey"));

  useEffect(() => {
    if (userlog === undefined || userlog === null) {
      navigate("/");
    }
  }, []);
  return (
    <>
      <Header />
      <Sidebar />
      <UploadeODA />
    </>
  );
};

export default UploadODAAdmin;
